import React from "react";
import { Cell } from "fixed-data-table-2";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FontAwesomeIconDropDown from "../drop-down/FontAwesomeIconDropDown";
import {
  faLongArrowAltDown,
  faLongArrowAltUp,
  faSortAlphaDown,
  faSortAlphaUp,
} from "@fortawesome/free-solid-svg-icons";
import { ColumnNames, Sorting } from "../../EvidenceTable";
import { Portal } from "react-portal";

type Props = {
  onSort: (columnName: ColumnNames) => any;
  sorting: Sorting;
  isReadonly?: boolean;
};

const StudentHeaderCell = (props: Props) => {
  return (
    <Cell className="w-100">
      <div className="d-flex align-items-center justify-content-between">
        <Dropdown className="w-40 lh-15">
          <Dropdown.Toggle
            as={FontAwesomeIconDropDown(
              <span  className={`text-left ${props.isReadonly ? 'default-pointer' : ''}`}>
                Student
                {props.sorting.column === ColumnNames.STUDENT 
                && props.sorting.sortingCount 
                ? (
                  <>
                  <FontAwesomeIcon
                    className="ml-1"
                    style={{ color: "black" }}
                    icon={
                      props.sorting.direction === "asc"
                        ? faSortAlphaUp
                        : faSortAlphaDown
                    }
                  />
                  <span className="font-weight-bold font-size-teacher">(Sorted By Student)</span>
                  </>
                ) : ''}
                {props.sorting.column === ColumnNames.TEACHER 
                && props.sorting.sortingCount 
                ? (
                  <>
                   
                   <FontAwesomeIcon
                    className="ml-1"
                    style={{ color: "black" }}
                    icon={
                      props.sorting.direction === "asc"
                        ? faSortAlphaUp
                        : faSortAlphaDown
                    }
                  />
                   <span className="font-weight-bold font-size-teacher">(Sorted By Teacher)</span>
                  </>
                ): ''}
              </span>
            )}
            id={"dropdownToggleStudent"}
          />
          <Portal>
            <OverlayTrigger
              overlay={
                <Tooltip id="fullName" className="customInfoTooltip">
                  <span>Sorting is based on the data rows currently displayed. Load more rows if needed.</span>
                </Tooltip>
              }
            >
              <Dropdown.Menu>
                <Dropdown.Item onClick={props.onSort(ColumnNames.STUDENT)}>
                {(props.sorting.sortingCount > 1) && props.sorting.column === ColumnNames.STUDENT ? `Click to reset`: `Sort by Student`}
                </Dropdown.Item>  
                <Dropdown.Item onClick={props.onSort(ColumnNames.TEACHER)}>
                {(props.sorting.sortingCount > 1) && props.sorting.column === ColumnNames.TEACHER ? `Click to reset`: `Sort by Teacher`}
                </Dropdown.Item>        
              </Dropdown.Menu>
            </OverlayTrigger>
          </Portal>
        </Dropdown>
        <OverlayTrigger
          overlay={
            <Tooltip id="fullName" className="customInfoTooltip">
              <span>Sorting is based on the data rows currently displayed. Load more rows if needed.</span>
            </Tooltip>
          }
        >
            <span className="pl-1" onClick={props.onSort(ColumnNames.CLASS)}>
              {props.sorting.column === ColumnNames.CLASS 
              && props.sorting.sortingCount 
              ? (
                <FontAwesomeIcon
                  className="mr-1"
                  style={{ color: "black" }}
                  icon={
                    props.sorting.direction === "asc"
                      ? faLongArrowAltUp
                      : faLongArrowAltDown
                  }
                />
              ): ''}
              Class
            </span>
            </OverlayTrigger>
            {!props.isReadonly
               ? 
            <OverlayTrigger
              overlay={
                <Tooltip id="fullName" className="customInfoTooltip">
                  <span>Sorting is based on the data rows currently displayed. Load more rows if needed.</span>
                </Tooltip>
              }
            >
              <span className="mr-1" onClick={props.onSort(ColumnNames.GRADE)}>
                {props.sorting.column === ColumnNames.GRADE 
                && props.sorting.sortingCount 
                ? (
                  <FontAwesomeIcon
                    className="mr-1"
                    style={{ color: "black" }}
                    icon={
                      props.sorting.direction === "asc"
                        ? faLongArrowAltUp
                        : faLongArrowAltDown
                    }
                  />
                ): ''}
                Grade
              </span> 
            </OverlayTrigger>
               :
               <span className="mr-1 default-pointer">
                {props.sorting.column === ColumnNames.GRADE 
                && props.sorting.sortingCount 
                ? (
                  <FontAwesomeIcon
                    className="mr-1"
                    style={{ color: "black" }}
                    icon={
                      props.sorting.direction === "asc"
                        ? faLongArrowAltUp
                        : faLongArrowAltDown
                    }
                  />
                ): ''}
                Grade
              </span> 
            }
      </div>
    </Cell>
  );
};

export default StudentHeaderCell;
